export default "__VITE_ASSET__BbYFlX2i__"